import { SafeResourceUrl } from '@angular/platform-browser';
import { appInjector } from '../app-injector';
import { Util } from '../core-utilities/Util';

// THIS NEEDS TO BE USED EVERYWHERE PDFS ARE BEING GENERATED
export class PdfReference {
    blob: Blob;
    safeUrl: SafeResourceUrl;

    static async createPdfReference(blob: Blob): Promise<PdfReference> {
        return Promise.resolve(new PdfReference(blob));
    }

    private constructor(blob: Blob, hideChromePdfTools = true) {
        this.blob = blob;
        const util = appInjector().get(Util);
        this.safeUrl = util.blobToSafeResourceUrl(blob, hideChromePdfTools);
    }

    print() {
        const iframe: HTMLIFrameElement = document.createElement('iframe');
        iframe.style.visibility = 'hidden'; // the user doesn't need to see this
        iframe.style.position = 'fixed';
        document.body.appendChild(iframe);
        iframe.src = encodeURI(window.URL.createObjectURL(this.blob));
        iframe.onload = () => {
            iframe.contentWindow.print();
        };
    }

    download(filename: string) {
        /**
         * There is an issue in IE, Firefox & Edge where, despite setting content type
         * properly, reports are being downloaded as generic files causing user frustration.
         * So I have put this check here in an attempt to ensure that all pdfs downloaded end in .pdf
         */
        if (
            !filename.endsWith('.pdf') &&
            !filename.endsWith('.csv') &&
            !filename.endsWith('.zip')
        ) {
            // Added check for .csv extension so org upload doesn't break
            filename = `${filename}.pdf`;
        }

        const elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(this.blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }

    getSafeResourceUrl(): SafeResourceUrl {
        return this.safeUrl;
    }
}
